/* eslint-disable */
console.log(
	"\n%c                   𝚍𝚎𝚟𝚎𝚕𝚘𝚙𝚎𝚍 𝚋𝚢\n%c                               \n    __   __  |__  o _|_   __  |   \n   (__) |  ' |__) |  |_, (__( |_, \n                               \n%c     𝚖𝚊𝚒𝚜 𝚎𝚖 𝚘𝚛𝚋𝚒𝚝𝚊𝚕.𝚌𝚘𝚖𝚙𝚊𝚗𝚢     \n",
	'color: #ccc;',
	'color: #de9f00;',
	'background: #000;'
);
